module.exports = __webpack_public_path__ + "media/images/logo_avatar_thumb_30-9b6f7f70ba7e26d6b614eb3c1c81f3cd.png";